import * as constants from '../constants';
import * as types from '../types';
import { LoadAllStylesLandingPageData } from '../actions/all-styles-landing-page';

const getDefaultState = () => ({
    styles: [],
});

export function allStylesLandingPageData(state: types.AllStylesLandingPageData = getDefaultState(), action: LoadAllStylesLandingPageData) {
    switch (action.type) {
        case constants.LOAD_ALL_STYLES_LANDING_PAGE_DATA:
            return { ...state, styles: action.payload };
        default:
            return state;
    }
}

export default allStylesLandingPageData;
